import React from 'react';
import { ListItem, Col, Row } from '@op/opds.opux';
import { useMessageGetter } from '@messageformat/react';
import { PERSON_REPRESENTATION_TYPES } from '../../../constants';

const RepresentationRow = ({ rep, onClick }) => {
    const msg = useMessageGetter('fp');

    const isPerson = () => {
        return PERSON_REPRESENTATION_TYPES.includes(rep.representationType);
    };

    const getTitle = () => {
        let name = rep.representationName;
        if (rep.agreementCount > 1 && !isPerson()) {
            name += ' ' + msg('representation.doubleAgreement.' + rep.representationType);
        }
        return name;
    };

    const getAriaLabel = () => {
        if (isPerson()) {
            return getTitle();
        } else {
            const businessIdWithSpaces = rep?.repCustomerID.split('').join(' ');
            return getTitle() + ' ' + msg('accessibility.businessId') + ' ' + businessIdWithSpaces;
        }
    };

    return (
        <ListItem onClick={() => onClick(rep)} data-company-type={rep.representationType} aria-label={getAriaLabel()}>
            <Row className='representation-row'>
                <Col xs={12} className='representation-row-title'>
                    {getTitle()}
                </Col>
                <Row className='representation-row'>
                    <Col xs={12} className='representation-company-id'>
                        {!isPerson() && rep.repCustomerID}
                    </Col>
                </Row>
            </Row>
        </ListItem>
    );
};

export default RepresentationRow;
